<template>
  <vx-card>
    <div class="vx-row">
      <div class="vx-col md:w-1/12 w-full">
        <h6 class="mb-2">Sigla</h6>
        <vs-input name="sigla" class="w-full" v-validate="'required'" readonly :value="data.sigla" />
        <span class="text-danger text-sm" v-show="errors.has('sigla')">{{ errors.first('sigla') }}</span>
      </div>
      <div class="vx-col md:w-11/12 w-full">
        <h6 class="mb-2">Descrição</h6>
        <vs-input name="descricao" v-uppercase v-validate="'required'" v-model="data.descricao" class="w-full"></vs-input>
        <span class="text-danger text-sm" v-show="errors.has('descricao')">{{ errors.first('descricao') }}</span>
      </div>
    </div>
    <div class="flex flex-wrap items-center" slot="footer">
      <vs-button class="mr-6" @click="submitData()">Salvar</vs-button>
    </div>
  </vx-card>
</template>

<script>
import axios from 'axios'
import { baseApiUrl } from "@/global"
import { Validator } from 'vee-validate';

const dict = {
  custom: {
    sigla: { required: 'Selecione uma sigla' },
    descricao: { required: 'Digite a descrição' },
  }
};

Validator.localize('en', dict);

export default {
  data() {
    return {
      initial: undefined,
      data: {}
    }
  },
  methods: {
    async loadDescriptionByInitial() {
      try {
        this.$vs.loading();
        const response = await axios.get(`${baseApiUrl}/descriptions/${this.initial}`);
        console.log(response.data);
        this.data = response.data
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel carregar" + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async submitData() {
      const haveErrors = !(await this.$validator.validateAll())
      if (haveErrors)
        return

      try {
        this.$vs.loading();
        const response = await axios.put(`${baseApiUrl}/descriptions/${this.initial}`, this.data);
        this.$vs.notify({
          color: 'success',
          title: 'Editado',
          text: `Descrição editada com successo.`
        })
        this.$router.push({ name: 'importation-description-list' })
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel salvar: " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close();
      }

    }
  },
  async created() {
    this.initial = this.$route.params.initial
    await this.loadDescriptionByInitial()
  }
}

</script>
